function removeTabIndexFromDropdownButtons() {
  document
    .querySelectorAll(".formkit-listboxButton, .formkit-openButton, .formkit-suffixIcon")
    .forEach((btn) => {
      btn.setAttribute("tabindex", "-1");
    });
}

function focusFirstAvailableInput() {
  const elem = (document.querySelector('form input:placeholder-shown:not(:disabled):not([type="checkbox"])') as HTMLInputElement|null);

  elem?.focus();
}

/**
 * TODO: Check if there is ANY event that allows us to do this without timeout.
 * @node triggers before mounting.
 */
function onInputMounted() {
  setTimeout(() => {
    removeTabIndexFromDropdownButtons();
  }, 100);
}

function onFormMounted() {
  onInputMounted();
  setTimeout(() => {
    focusFirstAvailableInput();
  }, 100);
}

export { onInputMounted, onFormMounted };
